// extracted by mini-css-extract-plugin
export default {"tag":"tag_tag__K+8tP","tag_success":"tag_tag_success__ywDiI","tag_warning":"tag_tag_warning__t5hBj","tag_danger":"tag_tag_danger__IpitR"};